import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClearedCheckImportRequest } from '@app/models/fund-management';

@Injectable()
export class ImportClearedChecksService {
	constructor(private readonly http: HttpClient) {}

	isImportEnabledForBank(id: number): Observable<any> {
		return this.http.get(`/api/banks/${id}/has-cleared-check-layout`);
	}

	importClearedChecks(data: ClearedCheckImportRequest): Observable<any> {
		return this.http.post('/api/outstandingcheck/clear-checks-from-import-text', data);
	}
}
